import { createSelector } from "@reduxjs/toolkit";
import {RootState} from "../store";

export const selectCurrentUser = ({auth}: RootState) => auth.currentSession?.user;
export const selectLoggedUser = ({auth}: RootState) => auth.loggedUsers;
export const selectIsChangingAccount = ({auth}: RootState) => auth.isChangingAccount;
export const selectCurrentCulture = createSelector(
    (state: RootState) => state.auth.currentSession?.user?.culture,
    culture => culture
);